import {createSlice} from "@reduxjs/toolkit";

const initialPermissionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  permissionForEdit: undefined,
  loadData:undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState: initialPermissionsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    configurationLoadedData: (state, action) => {
      state.error = null;
      state.loadData = action.payload.loadData;
      state.actionsLoading = false;
    },
    // getPermissionById
    permissionFetched: (state, action) => {
      state.actionsLoading = false;
      state.permissionForEdit = action.payload.permissionForEdit && action.payload.permissionForEdit.data;
      state.error = null;
    },
    // findPermissions
    permissionsFetched: (state, action) => {
      const { totalCount, list } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = list;
      state.totalCount = totalCount;
    },
    // createPermission
    permissionCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.permission);
    },
    // updatePermission
    permissionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity.id === action.payload.permission.id) {
      //     return action.payload.permission;
      //   }
      //   return entity;
      // });
    },
    // deletePermission
    permissionDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletePermissions
    permissionsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // permissionsUpdateState
    permissionsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
